<template>

	<div class="container">

		<div class="no-gutters text-center pb-3">
			<span property="itemListElement" typeof="ListItem">
				<a property="item" typeof="WebPage" title="Go to EveryLink." href="/" class="home">
					<span property="name">EveryLink</span>
				</a>
				<meta property="position" content="1">
			</span>
			<span property="itemListElement" typeof="ListItem">
				<span class="d"> &gt; </span>
				<a property="item" typeof="WebPage" title="Go to EveryLink." href="/people" class="home">
					<span property="name">People</span>
				</a>
				<meta property="position" content="1">
			</span>
			<span property="itemListElement" typeof="ListItem">
				<span class="d"> &gt; </span>
				<a property="item" typeof="WebPage" title="Go to EveryLink." href="/profile-edit" class="home">
					<span property="name">Edit Profile</span>
				</a>
				<meta property="position" content="1">
			</span>
			<span property="itemListElement" typeof="ListItem">
				<span class="d"> &gt; </span>
				<span property="name">Manage Friends</span>
				<meta property="position" content="3">
			</span>
		</div>

		<div class="d-flex justify-content-center">
			<Skeletor class="my-3" v-if="isLoading" circle size="120" />
			<div v-else class="avatar my-3" :style="{ backgroundImage: `url(${getAvatar})` }"></div>
		</div>

		<div class="row no-gutters">
			<div class="col-12 text-center">
				<Skeletor class="mx-auto mb-2" v-if="isLoading" width="300" height="35" />
				<h2 v-else class="d-inline-block align-middle">
					{{ getFullName }}
				</h2>
			</div>
		</div>

		<div class="row no-gutters">
			<div class="col-12 text-center">
				<p>
					You have
					<Skeletor class="mx-auto d-inline-block" v-if="isLoading" width="15" height="10" />
					<b v-else>{{ getFriends?.length }}</b> Friends
				</p>
			</div>
		</div>

		<div class="row justify-content-center text-center mt-5">
			<div class="card border p-0">
				<div class="card-header border-bottom py-3">
					<h4 class="card-header-title mb-0">New Friend Requests <span
						class="badge bg-primary d-inline-block">{{ getFriendRequests?.length }}</span></h4>
				</div>

				<div class="card-body m-2 mt-4">
					<ol v-if="isLoading" class="list-group text-start m-0 p-0">
						<Skeletor v-for="index in 3" :key="index" class="mx-auto mb-3" width="100%" height="50" pill />
					</ol>
					<ol v-else class="list-group text-start m-0 p-0">
						<li v-for="friendRequest in getFriendRequests" :key="friendRequest._id"
							class="list-group-item d-flex justify-content-between align-items-center">
							<div class="avatar avatar--mini flex-shrink-0 me-1" :style="{ backgroundImage: `url(${friendRequest.sender.avatar})` }"></div>
							<div class="ms-2 me-auto">
								<div class="fw-bold">{{ friendRequest.sender.firstName }}
									{{ friendRequest.sender.lastName }}
								</div>
								Friend request
							</div>
							<button @click="acceptRequest(friendRequest.sender._id)"
									class="badge d-flex p-2 align-items-center text-bg-primary rounded-pill">
								<span class="px-1 text-light text-decoration-none">Accept</span>
							</button>
							<button @click="rejectRequest(friendRequest.sender._id)"
									class="badge d-flex p-2 align-items-center text-bg-secondary rounded-pill ms-2">
								<span class="px-1 text-light text-decoration-none">Reject</span>
							</button>
						</li>
					</ol>
				</div>
			</div>
		</div>

		<div class="row justify-content-center text-center mt-5">
			<div class="card border p-0">
				<div class="card-header border-bottom py-3">
					<h4 class="card-header-title mb-0">Manage Friends <span
						class="badge bg-secondary d-inline-block">{{ getFriends?.length }}</span></h4>
				</div>
				<div class="card-body m-2 mt-4">
					<ol v-if="isLoading" class="list-group text-start m-0 p-0">
						<Skeletor v-for="index in 3" :key="index" class="mx-auto mb-3" width="100%" height="50" pill />
					</ol>
					<ol v-else class="list-group text-start m-0 p-0">
						<li v-for="friend in getFriends" :key="friend._id"
							class="list-group-item d-flex justify-content-between align-items-center">
							<div class="avatar avatar--mini flex-shrink-0 me-1" :style="{ backgroundImage: `url(${friend._id.avatar})` }"></div>
							<div class="ms-2 me-auto">
								<div class="fw-bold">{{ friend._id.firstName }}
									{{ friend._id.lastName }}
								</div>
							</div>
							<router-link :to="`/person/?id=${friend._id.wpId}`" class="badge d-flex p-2 align-items-center text-bg-primary rounded-pill">
								<span class="px-1 text-light text-decoration-none">View</span>
							</router-link>
							<button v-if="friend.blockFriend" @click="unblockFriend(friend._id._id)" class="badge d-flex p-2 align-items-center text-bg-secondary rounded-pill ms-2">
								<span class="px-1 text-light text-decoration-none">Unblock</span>
							</button>
							<button v-else @click="blockFriend(friend._id._id)" class="badge d-flex p-2 align-items-center text-bg-secondary rounded-pill ms-2">
								<span class="px-1 text-light text-decoration-none">Block</span>
							</button>
						</li>
					</ol>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
/* eslint-disable */
import { defineComponent } from 'vue'
import axios from 'axios';

interface IUser {
	_id?: number
	wpId: number
	firstName: string
	lastName: string
	email: string
	friendRequests?: object[]
	friends?: object[]
	avatar?: string
	posts?: object[]
}

export default defineComponent({
	name: 'MenageFriendsView',
	data(){
		return {
			isLoading: false,
			wpUser: null as IUser | null,
			currentUser: null as IUser | null,
			person: null as IUser | null,
		};
	},
	computed: {
		getFullName(){
			return this.currentUser?.firstName + ' ' + this.currentUser?.lastName
		},
		getAvatar(){
			return this.currentUser?.avatar
		},
		getPosts(){
			return this.currentUser?.posts || null
		},
		getFriends(){
			return this.currentUser?.friends || null
		},
		getFriendRequests(){
			return this.currentUser?.friendRequests || null
		},
	},
	async mounted(){
		this.isLoading = true
		await this.getUserFromWp()
		await this.getUser()
		this.isLoading = false
	},
	methods: {
		async getUserFromWp(){
			try {
				const res = await axios.get('/api/get_current_user.php')
				this.wpUser = res.data
			} catch (err){
				console.log(err)
			}
		},
		async getUser(){
			try {
				const res = await axios.get(`${process.env.VUE_APP_BASE_API_URI}/users/${this.wpUser?.wpId}`)
				this.currentUser = res.data
			} catch (err){
				console.log(err)
			}
		},

		async acceptRequest(id: number){
			try {
				await axios.post(`${process.env.VUE_APP_BASE_API_URI}/friend/accept-request`, {
					senderId: id,
					recipientId: this.currentUser?._id,
				})
				await this.getUser()
			} catch (err){
				console.log(err)
			}
		},

		async rejectRequest(id: number){
			try {
				await axios.post(`${process.env.VUE_APP_BASE_API_URI}/friend/reject-request`, {
					senderId: id,
					recipientId: this.currentUser?._id,
				})
				await this.getUser()
			} catch (err){
				console.log(err)
			}
		},

		async blockFriend(id: number){
			try {
				await axios.put(`${process.env.VUE_APP_BASE_API_URI}/users/${this.currentUser?._id}/block`, {
					friendBlock: id
				})
				await this.getUser()
			} catch (err){
				console.log(err)
			}
		},

		async unblockFriend(id: number){
			try {
				await axios.put(`${process.env.VUE_APP_BASE_API_URI}/users/${this.currentUser?._id}/unblock`, {
					friendBlock: id
				})
				await this.getUser()
			} catch (err){
				console.log(err)
			}
		}
	},
})
</script>

<style scoped>

</style>
